import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"

import ReactPlayer from "react-player"

import { css } from "@emotion/react"
import { rgba } from "polished"

import { whichDevice } from "../components/util-functions"
import { globalColors } from "./css-functions"

const TopBg = () => {
  const [ windowSize, setWindowSize ] = useState({ width: 0, height: 0 })
  const [ timeoutId, setTimeoutId ] = useState(0)
  const [ videoSize, setVideoSize ] = useState({ width: 0, height: 0 })
  const [ cssBackground, setCssBackground ] = useState(`background-color: ${ globalColors.black };`)

  const device = whichDevice()

  const { allFile } = useStaticQuery(graphql`
    query {
      allFile(filter: {name: {regex: "/top_bg/"}}, sort: {fields: name}) {
        edges {
          node {
            publicURL
          }
        }
      }
    }
  `)

  useEffect(() => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight })

    const handleWindowSize = () => {
      setTimeoutId(setTimeout(() => {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight })
      }, 500))
    }

    window.addEventListener("resize", handleWindowSize)

    const hiddenAreaSize = 264

    if ( ( 16 / 9 ) > ( windowSize.width / windowSize.height ) ) {
      const baseLength = windowSize.height + hiddenAreaSize
      const width = baseLength * ( 16 / 9 )
      const height = baseLength

      setVideoSize({ width: width, height: height })
    } else {
      if ( windowSize.width * ( 9 / 16 ) - windowSize.height < hiddenAreaSize ) {
        const baseLength = windowSize.height + hiddenAreaSize
        const width = baseLength * ( 16 / 9 )
        const height = baseLength

        setVideoSize({ width: width, height: height })
      } else {
        const baseLength = windowSize.width
        const width = baseLength
        const height= baseLength * ( 9 / 16 )

        setVideoSize({ width: width, height: height })
      }
    }

    return () => {
      window.removeEventListener("resize", handleWindowSize)
      clearTimeout(timeoutId)
    }
  }, [ timeoutId, windowSize.width, windowSize.height ])

  useEffect(() => {
    const portraitBaseScale = `( 100vh * ( 1080 / 1000 ) + 100px )`
    const landscapeBaseScale = `( ( 100vw + 100px ) * ( 1080 / 1000 ) )`
    if ( !device.isIPhone && !device.isAndroid ) {
      setCssBackground(`background-color: ${ globalColors.black };`)
    } else {
      setCssBackground(`
        opacity: 0;
        z-index: 0;
        @media screen and ( orientation: portrait ) {
          background-size: calc( ${ portraitBaseScale } ) calc( ${ portraitBaseScale } * ( 1000 / 1080 ) );
        }
        @media screen and ( orientation: landscape ) {
          background-size: calc( ${ landscapeBaseScale } * ( 1080 / 1000 ) ) calc( ${ landscapeBaseScale } );
        }
        background-image: url( ${ allFile.edges[0].node.publicURL } );
        background-position: 0 center;
        background-repeat: no-repeat;
        animation: bgSlide 20s 0s linear infinite;
        &:nth-of-type(2) {
          background-image: url( ${ allFile.edges[1].node.publicURL } );
          animation-delay: 5s;
        }
        &:nth-of-type(3) {
          background-image: url( ${ allFile.edges[2].node.publicURL } );
          background-position: -100px center;
          animation: bgSlide_reverse 20s linear infinite;
          animation-delay: 10s;
        }
        &:nth-of-type(4) {
          background-image: url( ${ allFile.edges[3].node.publicURL } );
          animation-delay: 15s;
        }
        @keyframes bgSlide {
          0% {
            background-position: 0 center;
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          40% {
            opacity: 1;
          }
          50% {
            opacity: 0;
            background-position:  -300px center;
            z-index: -1;
          }
        }
        @keyframes bgSlide_reverse {
          0% {
            background-position: -100px center;
            opacity: 0;
          }
          10% {
            opacity: 1;
          }
          40% {
            opacity: 1;
          }
          50% {
            opacity: 0;
            background-position: 0 center;
            z-index: -1;
          }
        }
      `)
    }
  }, [ device.isIPhone, device.isAndroid, allFile.edges ])

  const style = {
    imgWrapper: css`
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate( -50%, -50% );
      ${ cssBackground }
    `,
    videoWrapper: css`
      width: ${ videoSize.width }px;
      height: ${ videoSize.height }px;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate( -50%, -50% );
      pointer-events: none;
    `,
    overlay: css`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: ${ rgba( globalColors.black, 0.6 ) };
    `,
  }

  return (
    <>
      <div css={ style.imgWrapper } className="imageBg" />
      <div css={ style.imgWrapper } className="imageBg" />
      <div css={ style.imgWrapper } className="imageBg" />
      <div css={ style.imgWrapper } className="imageBg" />
      { ( !device.isIPhone && !device.isAndroid ) &&
        <div
          css={ style.videoWrapper }
          className="videoBg"
        >
          <ReactPlayer
            url="https://www.youtube.com/watch?v=ONwqXPPUC_o"
            muted={ true }
            loop={ true }
            config={{
              youtube: {
                playerVars: {
                  autoplay: 1,
                  rel: 0,
                  modestbranding: 1,
                  loop: 1,
                  disablekb: 1,
                  controls: 0,
                },
              }
            }}
            width="100%"
            height="100%"
          />
          <div css={ style.overlay } />
        </div>
      }
    </>
  )
}

export default TopBg